const Cookies = require("js-cookie");

module.exports = function () {
  const alertBanner = document.querySelector(".alert-banner");
  if (!alertBanner) return;

  const closeButton = alertBanner.querySelector(".alert-banner__close");
  const cookieId = alertBanner.id;
  const cookieName = `innophos_banner_${cookieId}`;

  const displayBanner = (cookieName) => {
    if (Cookies.get(cookieName)) {
      alertBanner.style.display = "none";
    } else {
      alertBanner.style.display = "block";
    }
  };

  displayBanner(cookieName);

  const handleClose = () => {
    alertBanner.style.display = "none";
    Cookies.set(cookieName, cookieId, {
      expires: parseInt(alertBanner.dataset.cookieExpiration, 10) || 1,
    });
  };

  closeButton.addEventListener("click", handleClose);
};
